<template>
    <v-card class="pl-2 pl-md-10 pr-1 pr-md-2 pa-1 app-screen-bg ">
        <div class="toplist-sticky-title">
            <span class="toplist-title-pill">{{ $t('dashboard.toplist.titlePill') }}</span>
        </div>
        <v-row class="ma-0" dense>
            <v-col class="col-12 col-md-6 col-lg-4 order-0 order-lg-1">
                <v-card class="justify-center pa-2 ml-0 mr-0" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'">
                    <v-card-title class="justify-center"  style="position: relative;z-index: 1;">
                        {{ $t('dashboard.toplist.leagueTournamentTitle') }}
                    </v-card-title>
                    <v-card-text class="justify-center" style="position: relative;">
                        <div style="opacity: 0.8; position: absolute; inset: 0;">
                            <v-img
                                :src="require(`@/assets/pic/web/trophy.png`)"
                                contain
                                style="z-index: 0;opacity: 0.65; height: 80%; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                            />
                        </div>
                        <ToplistTable
                            class="toplist-table-fix"
                            style="position: relative;z-index: 1;"
                            :toplist="leagueToplist"
                            :actual-trainer="leagueTrainerToplistsRank"
                            :headers="defaultToplistHeaders"
                            :keys="['index','trainer','day','round','created']"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="col-12 col-md-6 col-lg-4 order-1 order-lg-0">
                <v-card class="justify-center pa-2 ml-0 mr-0" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'">
                    <v-card-title class="justify-center" style="word-break: break-all">
                        {{ $t('dashboard.toplist.dungeonChallengesTitle') }}
                        <v-switch
                            style="position: absolute; top: 12px; right: 12px;"
                            v-model="challengeGlobal"
                            inset
                            :loading="isLoading"
                            color="accent"
                            :label="challengeGlobal ? $t('dashboard.toplist.switchGlobal') : $t('dashboard.toplist.switchAtDay', {days})"
                        />
                    </v-card-title>
                    <v-card-text class="justify-center">
                        <ToplistTable
                            class="toplist-table-fix"
                            style="position: relative;z-index: 1;"
                            v-if="toplistChallenge"
                            :toplist="toplistChallenge"
                            :headers="dungeonToplistHeaders"
                            :keys="['index','trainer','elo','days','created']"
                            :actual-trainer="toplistChallengeTrainer"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="col-12 col-md-6 col-lg-4 order-2" >
                <v-card class="justify-center pa-2 ml-0 mr-0" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'">
                    <v-card-title class="justify-center" style="word-break: break-all">
                        {{ $t('dashboard.toplist.dungeonsTitle') }}
                        <v-switch
                            v-model="dungeonGlobal"
                            :loading="isLoading"
                            inset
                            style="position: absolute; top: 12px; right: 12px;"
                            color="accent"
                            :label="dungeonGlobal ? $t('dashboard.toplist.switchGlobal') : $t('dashboard.toplist.switchAtDay', {days})"
                        />
                    </v-card-title>
                    <v-card-text class="justify-center">
                        <ToplistTable
                            class="toplist-table-fix"
                            style="position: relative;z-index: 1;"
                            v-if="toplist"
                            :toplist="toplist"
                            :headers="dungeonToplistHeaders"
                            :keys="['index','trainer','elo','days','created']"
                            :actual-trainer="toplistTrainer"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="col-12 col-md-6 col-lg-4"  v-for="(badgeToplist,index) in trainerToplists" :key="'tra_'+index" :class="'order-'+(3+index)">
                <v-card class="justify-center pa-2 ml-0 mr-0" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'">
                    <v-card-text class="justify-center" style="position: relative;">
                        <div style="opacity: 0.8; position: absolute; inset: 0;">
                            <v-img
                                :src="require(`@/assets/pic/badge/${index+1}.png`)"
                                contain
                                style="z-index: 0;opacity: 0.65; height: 100%; max-height: 400px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
                            >
                            </v-img>
                            <v-img
                                :src="require(`@/assets/pic/trainer/${index+1}.png`)"
                                contain
                                style="height: 50%; opacity: 1; max-height: 400px;max-width: 50%; position: absolute; bottom: 10%; right: 10%;"
                            />
                        </div>

                        <ToplistTable
                            class="toplist-table-fix"
                            style="position: relative;z-index: 1;"
                            :toplist="badgeToplist"
                            :actual-trainer="trainerToplistsRank[index+1]"
                            :headers="defaultToplistHeaders"
                            :keys="['index','trainer','day','round','created']"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col class="col-12 col-md-6 col-lg-4 order-12">
                <v-card class="justify-center pa-2 ml-0 mr-0" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'">
                    <v-card-title class="justify-center">
                        <v-autocomplete
                            style="position:relative; z-index: 2"
                            filled
                            v-model="trainerForWildToplists"
                            color="accent"
                            item-color="accent"
                            :loading="isLoading"
                            :label="$t('dashboard.toplist.trainerSelectLabel')"
                            item-text="name"
                            item-value="id"
                            :items="trainersForToplists"
                        ></v-autocomplete>
                    </v-card-title>
                    <v-card-text class="justify-center" style="position: relative;">
                        <div style="opacity: 0.8; position: absolute; inset: 0;">
                            <v-img
                                :src="require(`@/assets/pic/trainer/${imgWildTrainer}`)"
                                contain
                                style="max-height: 65%; max-width: 65%; min-height: 40%; min-width: 40%; position: absolute; bottom: 10%; right: 10%;"
                            />
                        </div>
                        <ToplistTable
                            class="toplist-table-fix"
                            style="position:relative; z-index: 1"
                            :toplist="trainerWildFightToplist"
                            :actual-trainer="trainerWildFightToplistRank"
                            :headers="defaultToplistHeaders"
                            :keys="['index','trainer','day','round','created']"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-card>
</template>

<script>
    import {API_ENTRYPOINT} from "@/config/entrypoint";
    import {mapActions, mapGetters} from 'vuex';
    import ToplistTable from "../journey/positions/pieces/ToplistTable";

    export default {
        name: 'Toplist',
        components: {ToplistTable},
        data() {
            return {
                toplist: [],
                leagueToplist: [],
                leagueTrainerToplistsRank: null,
                toplistTrainer: null,
                toplistChallenge: [],
                dungeonGlobal: true,
                challengeGlobal: true,
                toplistChallengeTrainer: null,
                trainerToplists: [],
                trainerToplistsRank: [],
                trainersForToplists: [],
                trainerForWildToplists: null,
                trainerWildFightToplistRank: null,
                trainerWildFightToplist: [],
                imgWildTrainer: 'players/default1.png',
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'dashboard/isLoading',
                trainers:  'dashboard/items',
                user: 'user/item',
                days: 'journey/days',
                position: 'journey/position',
            }),
            // headers musi byt computed (ne data()/literal primo v sablone vicekrat) - $t() uvnitr potrebuje
            // reagovat na zmenu jazyka, sdilene pole navic snizuji duplikaci mezi jednotlivymi ToplistTable
            defaultToplistHeaders() {
                return ['', this.$t('dashboard.toplist.headerTrainer'), this.$t('dashboard.toplist.headerDay'), this.$t('dashboard.toplist.headerRound'), this.$t('dashboard.toplist.headerDate')];
            },
            dungeonToplistHeaders() {
                return ['', this.$t('dashboard.toplist.headerTrainer'), this.$t('dashboard.toplist.headerDungeonPoints'), this.$t('dashboard.toplist.headerDay'), this.$t('dashboard.toplist.headerDate')];
            },
        },
        watch: {
            trainerForWildToplists() {
                this.getTrainersWildFightToplist();
                this.actualiseWildTrainerPic();
            },
            dungeonGlobal() {
                this.getToplistDungeon();
            },
            challengeGlobal() {
                this.getToplistChallenge();
            },
        },
        created() {
            if (this.user.position !== undefined) {
                this.loadPosition(this.user.position.id).then(
                    () => {
                        this.getToplistDungeon();
                        this.getToplistChallenge();
                    }
                );
                this.getLeagueToplist();
                this.getTrainersFightToplists();
                this.getTrainersForToplists();
            }
        },
        methods: {
            ...mapActions({
                getTrainers: 'dashboard/loadOverview',
                fetchData: 'dashboard/fetchObject',
                loadPosition: 'journey/loadPosition',
            }),
            getToplistDungeon() {
                const url = new URL("api/get-dungeons-toplist", API_ENTRYPOINT);
                if (!this.dungeonGlobal) {
                    url.searchParams.set('day', this.days);
                }
                url.searchParams.set('trainer', this.user.id);
                const obj = {url: url,method:'GET'}
                this.fetchData(obj).then(
                    (data) => {
                        this.toplist = data['toplist'];
                        this.toplistTrainer = data['trainer'];
                    }
                );
            },
            getToplistChallenge() {
                const url = new URL("api/get-dungeons-toplist", API_ENTRYPOINT);
                url.searchParams.set('isChallenge', true.toString());
                if (!this.challengeGlobal) {
                    url.searchParams.set('day', this.days);
                }
                url.searchParams.set('trainer', this.user.id);
                const obj = {url: url,method:'GET'}
                this.fetchData(obj).then(
                    (data) => {
                        this.toplistChallenge = data['toplist'];
                        this.toplistChallengeTrainer = data['trainer'];
                    }
                );
            },
            getToplistTrainerFight(index) {
                const url = new URL("api/get-badge-toplist?itemsPerPage=10&badge="+index, API_ENTRYPOINT);
                const obj = {url: url,method:'GET'}
                this.fetchData(obj).then(
                    (data) => {
                        this.trainerToplists[index-1] = data;
                    }
                );

                const url2 = new URL("api/get-badge-trainer-toplist-position?", API_ENTRYPOINT);
                url2.searchParams.set('badge', (index).toString());
                url2.searchParams.set('trainer', this.user.id);
                const obj2 = {url: url2,method:'GET'}
                this.fetchData(obj2).then(
                    (data) => {
                        this.trainerToplistsRank[index-1] = data;
                    }
                );
            },
            getTrainersFightToplists() {
                for (let i =1; i <= 9; i++) {
                    this.getToplistTrainerFight(i);
                }
            },
            getTrainersForToplists() {
                const url = new URL("api/users?order[name]=asc&page=1&itemsPerPage=1000&npc=true&teamRocket=false", API_ENTRYPOINT);
                const obj = {url: url,method:'GET'}
                this.fetchData(obj).then(
                    (data) => {
                        this.trainersForToplists = data['member'];
                        if (this.trainersForToplists.length > 0) {
                            this.trainerForWildToplists = this.trainersForToplists[0].id;
                        }
                    }
                );
            },
            getTrainersWildFightToplist() {
                const url = new URL("api/get-trainers-toplist?", API_ENTRYPOINT);
                url.searchParams.set('wildTrainer', this.trainerForWildToplists);
                const obj = {url: url,method:'GET'}
                this.fetchData(obj).then(
                    (data) => {
                        this.trainerWildFightToplist = data;
                    }
                );

                const url2 = new URL("api/get-fight-trainer-toplist?", API_ENTRYPOINT);
                url2.searchParams.set('day', this.days);
                url2.searchParams.set('wildTrainer', this.trainerForWildToplists);
                url2.searchParams.set('trainer', this.user.id);
                const obj2 = {url: url2,method:'GET'}
                this.fetchData(obj2).then(
                    (data) => {
                        this.trainerWildFightToplistRank = data;

                    }
                );
            },
            actualiseWildTrainerPic() {
                let find = this.trainersForToplists.find((item) =>{return item.id === this.trainerForWildToplists; })
                if (find) {
                    this.imgWildTrainer = find.img;
                } else {
                    this.imgWildTrainer = 'players/default1.png';
                }
            },
            getLeagueToplist() {
                const url = new URL("api/league_toplists?order[day]=asc&order[created]=asc&page=1&itemsPerPage=10", API_ENTRYPOINT);
                const obj = {url: url,method:'GET'}
                this.fetchData(obj).then(
                    (data) => {
                        this.leagueToplist = data['member'];
                    }
                );

                const url2 = new URL("api/get-league-trainer-toplist-position?", API_ENTRYPOINT);
                url2.searchParams.set('trainer', this.user.id);
                const obj2 = {url: url2,method:'GET'}
                this.fetchData(obj2).then(
                    (data) => {
                        this.leagueTrainerToplistsRank = data;
                    }
                );
            },
        },
    }
</script>

<style scoped>
    .toplist-sticky-title {
        position: sticky;
        top: 0;
        z-index: 3;
        display: flex;
        justify-content: center;
        padding: 8px 0;
    }

    .toplist-title-pill {
        display: inline-block;
        background: rgba(0, 0, 0, .65);
        color: #fff;
        font-size: 20px;
        font-weight: 700;
        padding: 6px 20px;
        border-radius: 20px;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, .6);
    }

    /* Odsazeni bunek skaluje s poctem sloupcu v radku (viz col-12/col-md-6/col-lg-4 vyse) */
    ::v-deep .toplist-table-fix th,
    ::v-deep .toplist-table-fix td {
        padding: 4px !important;
    }

    @media (min-width: 960px) {
        ::v-deep .toplist-table-fix th,
        ::v-deep .toplist-table-fix td {
            padding: 8px !important;
        }
    }

    @media (min-width: 1264px) {
        ::v-deep .toplist-table-fix th,
        ::v-deep .toplist-table-fix td {
            padding: 12px !important;
        }
    }
</style>
